module.exports = __webpack_public_path__ + "static/img/com_02.5105fa3.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/com_02.png
// module id = bZN5
// module chunks = 12